// extracted by mini-css-extract-plugin
export default {"activityTable":"ActivityMatrixTable_activityTable__rHnqu"};